var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ChecklistItemDto } from '../../../classes/checklist-item';
import { BaseStringIdDataDto } from '../../../classes/common';
import { DispatchAreaWithoutRelationsDto } from '../../../classes/dispatch-area';
import { GarageDto } from '../../../classes/garage';
import { ReservationConsultationWithoutRelationsDto } from '../../../classes/reservation-consultation/response/reservation-consultation-without-relations.dto';
import { ReservationPaymentWithoutReservationDto } from '../../../classes/reservation-payment';
import { UserWithoutRelationsDto } from '../../../classes/user/response/user-without-relations.dto';
import { VehicleWithoutRelationsDto } from '../../../classes/vehicle';
import { VehicleModelWithoutRelationsDto } from '../../../classes/vehicle-model';
import { VendorWithoutRelationsDto } from '../../../classes/vendor/response/vendor-without-relations.dto';
import { ReservationConvenienceDto } from './reservation-convenience.dto';
import { ReservationDriverAttachmentDto } from './reservation-driver-attachment.dto';
import { ReservationExtensionDto } from './reservation-extension.dto';
import { ReservationExtraItemDto } from './reservation-extra-item.dto';
import { ReservationInsuranceDto } from './reservation-insurance.dto';
import { ReservationPersonDto } from './reservation-person.dto';
export class ReservationDto extends BaseStringIdDataDto {
    constructor(initializer) {
        var _a;
        super(initializer);
        this.pickUpAt = initializer.pickUpAt;
        this.pickUpGarageId = initializer.pickUpGarageId;
        this.pickUpGarage = initializer.pickUpGarage;
        this.dropOffAt = initializer.dropOffAt;
        this.actualDropOffAt = initializer.actualDropOffAt;
        this.dropOffGarageId = initializer.dropOffGarageId;
        this.dropOffGarage = initializer.dropOffGarage;
        this.billingTime = initializer.billingTime;
        this.vehicleModel = initializer.vehicleModel;
        this.vehicleModelId = initializer.vehicleModelId;
        this.reservedVehicleId = initializer.reservedVehicleId;
        this.reservedVehicle = initializer.reservedVehicle;
        this.insuranceOption = initializer.insuranceOption;
        this.pricingVersion = initializer.pricingVersion;
        this.listPrice = initializer.listPrice;
        this.finalPrice = initializer.finalPrice;
        this.offeredPrice = initializer.offeredPrice;
        this.settlementCommissionRate = initializer.settlementCommissionRate;
        this.settlementCommissionAmount = initializer.settlementCommissionAmount;
        this.priceLock = initializer.priceLock;
        this.directPaymentPrice = initializer.directPaymentPrice;
        this.checkDirectPayment = initializer.checkDirectPayment;
        this.cancellationFee = (_a = initializer.cancellationFee) !== null && _a !== void 0 ? _a : 0;
        this.state = initializer.state;
        this.manager = initializer.manager;
        this.managerId = initializer.managerId;
        this.vendor = initializer.vendor;
        this.vendorId = initializer.vendorId;
        this.route = initializer.route;
        this.allAges = initializer.allAges;
        this.guide = initializer.guide;
        this.email = initializer.email;
        this.customerName1 = initializer.customerName1;
        this.customerName2 = initializer.customerName2;
        this.customerPhoneNumber1 = initializer.customerPhoneNumber1;
        this.customerPhoneNumber2 = initializer.customerPhoneNumber2;
        this.memo = initializer.memo;
        this.vendorMemo = initializer.vendorMemo;
        this.payments = initializer.payments;
        this.insurances = initializer.insurances;
        this.extraItems = initializer.extraItems;
        this.conveniences = initializer.conveniences;
        this.extensions = initializer.extensions;
        this.reservationDriverAttachments =
            initializer.reservationDriverAttachments;
        this.expectedDepositDate = initializer.expectedDepositDate;
        this.expectedDepositFee = initializer.expectedDepositFee;
        this.expectedDepositMemo = initializer.expectedDepositMemo;
        // 차량대여
        this.releaseManager = initializer.releaseManager;
        this.releaseManagerId = initializer.releaseManagerId; // 출고인
        this.contractNo = initializer.contractNo;
        this.departureDate = initializer.departureDate;
        this.departureFuelRate = initializer.departureFuelRate;
        this.departureFuelRateUnit = initializer.departureFuelRateUnit;
        this.departureMileage = initializer.departureMileage;
        // 기타준비사항
        this.checklistItems = initializer.checklistItems;
        this.releasePreparation = initializer.releasePreparation;
        this.releasePreparationMemo = initializer.releasePreparationMemo;
        this.releasePreparedAt = initializer.releasePreparedAt;
        this.assignedVehicle = initializer.assignedVehicle;
        this.assignedVehicleId = initializer.assignedVehicleId;
        this.dispatchArea = initializer.dispatchArea;
        this.dispatchAreaId = initializer.dispatchAreaId;
        this.contractor = initializer.contractor;
        this.driver = initializer.driver;
        // 차량반납
        this.returnManager = initializer.returnManager;
        this.returnManagerId = initializer.returnManagerId;
        this.returnDate = initializer.returnDate;
        this.returnFuelRate = initializer.returnFuelRate;
        this.returnFuelRateUnit = initializer.returnFuelRateUnit;
        this.returnMileage = initializer.returnMileage;
        this.returnGarage = initializer.returnGarage; // 반납 후 차량의 위치 변경
        this.returnGarageId = initializer.returnGarageId;
        // 예약취소
        this.canceledAt = initializer.canceledAt;
        this.cancelReason = initializer.cancelReason;
        this.cancelManager = initializer.cancelManager;
        this.cancelManagerId = initializer.cancelManagerId;
        // 예약상담
        this.consultations = initializer.consultations;
        this.customerAirportArrived = initializer.customerAirportArrived;
        this.numberOfPassengers = initializer.numberOfPassengers;
        this.flightDepartedAt = initializer.flightDepartedAt;
        this.flightNumber = initializer.flightNumber;
        this.wantedVendor = initializer.wantedVendor;
        this.privacyAgreementSignatureUrl =
            initializer.privacyAgreementSignatureUrl;
        this.companyId = initializer.companyId;
        // 반려동물 동반 정보
        this.isWithPet = initializer.isWithPet;
        this.petType = initializer.petType;
        this.petCount = initializer.petCount;
        this.petTotalWeightKg = initializer.petTotalWeightKg;
        this.petBreed = initializer.petBreed;
        this.petPolicyAgreed = initializer.petPolicyAgreed;
        this.petPriceRate = initializer.petPriceRate;
        this.isReturning = initializer.isReturning;
        this.isMarketingAgreed = initializer.isMarketingAgreed;
        this.d2cUserId = initializer.d2cUserId;
        this.usedMileage = initializer.usedMileage;
        this.usedReferralCode = initializer.usedReferralCode;
        this.referralReferrerName = initializer.referralReferrerName;
        this.referralReferrerUserId = initializer.referralReferrerUserId;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationDto.prototype, "pickUpAt", void 0);
__decorate([
    Type(() => GarageDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "pickUpGarage", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationDto.prototype, "dropOffAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Date)
], ReservationDto.prototype, "actualDropOffAt", void 0);
__decorate([
    Type(() => GarageDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "dropOffGarage", void 0);
__decorate([
    Type(() => VendorWithoutRelationsDto),
    __metadata("design:type", VendorWithoutRelationsDto)
], ReservationDto.prototype, "vendor", void 0);
__decorate([
    Type(() => VehicleModelWithoutRelationsDto),
    __metadata("design:type", VehicleModelWithoutRelationsDto)
], ReservationDto.prototype, "vehicleModel", void 0);
__decorate([
    Type(() => VehicleWithoutRelationsDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "reservedVehicle", void 0);
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "manager", void 0);
__decorate([
    Type(() => ReservationPaymentWithoutReservationDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "payments", void 0);
__decorate([
    Type(() => ReservationInsuranceDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "insurances", void 0);
__decorate([
    Type(() => ReservationExtraItemDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "extraItems", void 0);
__decorate([
    Type(() => ReservationConvenienceDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "conveniences", void 0);
__decorate([
    Type(() => ReservationExtensionDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "extensions", void 0);
__decorate([
    Type(() => ReservationDriverAttachmentDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "reservationDriverAttachments", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ReservationDto.prototype, "expectedDepositDate", void 0);
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "releaseManager", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ReservationDto.prototype, "departureDate", void 0);
__decorate([
    Type(() => ChecklistItemDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "checklistItems", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ReservationDto.prototype, "releasePreparedAt", void 0);
__decorate([
    Type(() => VehicleWithoutRelationsDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "assignedVehicle", void 0);
__decorate([
    Type(() => DispatchAreaWithoutRelationsDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "dispatchArea", void 0);
__decorate([
    Type(() => ReservationPersonDto),
    __metadata("design:type", ReservationPersonDto)
], ReservationDto.prototype, "contractor", void 0);
__decorate([
    Type(() => ReservationPersonDto),
    __metadata("design:type", ReservationPersonDto)
], ReservationDto.prototype, "driver", void 0);
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "returnManager", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ReservationDto.prototype, "returnDate", void 0);
__decorate([
    Type(() => GarageDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "returnGarage", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ReservationDto.prototype, "canceledAt", void 0);
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", Object)
], ReservationDto.prototype, "cancelManager", void 0);
__decorate([
    Type(() => ReservationConsultationWithoutRelationsDto),
    __metadata("design:type", Array)
], ReservationDto.prototype, "consultations", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], ReservationDto.prototype, "flightDepartedAt", void 0);
